import React from "react";
import AsyncSelect from "react-select/async";
import { EntryTypes } from "../utils/constants";

const EntrySpecificSelect = ({
  entryType,
  formData,
  updateFormField,
  accountingData,
  translations,
  state,
}) => {
  const getDefaultValue = () => {
    if (!state) return "";

    switch (entryType) {
      case EntryTypes.AccSession:
        return `Accounting Session Id: ${state.AccSession?.id} Patient Id: ${state.AccSession?.patientId}`;
      case EntryTypes.Package:
        return `Package Id: ${state.Package?.id} Patient Id: ${state.Package?.patientId}`;
      case EntryTypes.UserBalance:
        return state.User?.id;
      case EntryTypes.AccThHour:
        return `Accounting Therapist Hour Id: ${state.AccThHour?.id}`;
      default:
        return "";
    }
  };

  const renderSelect = () => {
    const commonProps = {
      isClearable: true,
      className: "full-width",
      placeholder: getPlaceholder(),
      defaultOptions: getDefaultOptions(),
      loadOptions: getLoadFunction(),
      onChange: (e) => handleChange(e ? e.value : ""),
    };

    return (
      <div className="col-md-4 mt-4">
        <AsyncSelect {...commonProps} />
      </div>
    );
  };

  const getPlaceholder = () => {
    const placeholders = {
      [EntryTypes.AccSession]: `Accounting Session Id -- Auto Selected: ${getDefaultValue()}`,
      [EntryTypes.Package]: "Package Id",
      [EntryTypes.UserBalance]: "user",
      [EntryTypes.Salary]: "User Id",
      [EntryTypes.AccThHour]: `Accounting Therapist Hour Id -- Auto Selected: ${getDefaultValue()}`,
    };
    return placeholders[entryType] || "";
  };

  const getDefaultOptions = () => {
    const options = {
      [EntryTypes.AccSession]: accountingData.OptionSession,
      [EntryTypes.Package]: accountingData.OptionPackage,
      [EntryTypes.UserBalance]: accountingData.OptionUser,
      [EntryTypes.Salary]: accountingData.OptionUser,
      [EntryTypes.AccThHour]: accountingData.OptionTherapist,
    };
    return options[entryType] || [];
  };

  const getLoadFunction = () => {
    const functions = {
      [EntryTypes.AccSession]: accountingData.GetAccountingSessions,
      [EntryTypes.Package]: accountingData.GetPackages,
      [EntryTypes.UserBalance]: accountingData.GetUsers,
      [EntryTypes.Salary]: accountingData.GetUsers,
      [EntryTypes.AccThHour]: accountingData.GetAccountingTherapistHours,
    };
    return functions[entryType] || (() => Promise.resolve([]));
  };

  const handleChange = (value) => {
    const fieldMap = {
      [EntryTypes.AccSession]: "accountingSession",
      [EntryTypes.Package]: "package",
      [EntryTypes.UserBalance]: "user",
      [EntryTypes.Salary]: "user",
      [EntryTypes.AccThHour]: "accountingTherapistHourId",
    };

    const field = fieldMap[entryType];
    if (field) {
      updateFormField(field, value);
    }
  };

  if (
    !entryType ||
    ![
      EntryTypes.AccSession,
      EntryTypes.Package,
      EntryTypes.UserBalance,
      EntryTypes.Salary,
      EntryTypes.AccThHour,
    ].includes(entryType)
  ) {
    return null;
  }

  return renderSelect();
};

export default EntrySpecificSelect;
